import ErrorIcon from "@material-ui/icons/Error";
import React from "react";
import {toast} from "react-toastify";

const toastMessage = (message) => (
    <div style={{display: "inline-flex", alignItems: "center", paddingTop: "5px"}}>
        <ErrorIcon/>
        <div className={"ml-12"} style={{whiteSpace: 'pre-wrap'}}>
            {message}
        </div>
    </div>
)

export const toastSuccess = (message) => {
    toast.success(toastMessage(message), {
        position: toast.POSITION.BOTTOM_CENTER,
        draggable: false
    });
}

export const toastError = (message) => {
    toast.error(toastMessage(message), {
        position: toast.POSITION.BOTTOM_CENTER,
        draggable: false
    });
}

export const toastWarning = (message) => {
    toast.warning(toastMessage(message), {
        position: toast.POSITION.BOTTOM_CENTER,
        draggable: false
    });
}
